import React from 'react'
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";

// import moment from 'moment';
import 'moment/locale/pl'

import {Row, Col, Card, CardTitle,  CardHeader, CardBody, FormGroup, Collapse, Label, Input } from 'reactstrap'

import IndicatorsPage from '../IndicatorsPage'
import FilterPanel from './FilterPanel';
import MyIndicatorsChart from './MyIndicatorsChart'
import {FilterByDate} from "../../../../components/indicatorsComponets/DataFilter";
import IndicatorDescription from "../ComparativeIndicators/IndicatorDescription";
import LineChart from "../../../../components/indicatorsComponets/Plot/LineChart";

const MyIndicatorsPage = () => {
    const [openedCollapses, setOpenedCollapses] = React.useState([
        "statistics",
        "human_resource_cost",
        "collapseTwo",
        "collapse2",
      ]);

    const handleChangeDate = (date) => {
    }

    
    return (
        <IndicatorsPage>
            <Row>
                <Col className="ml-auto mr-auto" md="12">                    
                    <Card>
                        <CardBody>
                             <Row>

                                <FilterByDate/>

                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>
                {/* Filters */}
                <Col xl="2" md="3" sm="12">
                    <FilterPanel/>
                </Col>

                {/* Chart */}

                    <MyIndicatorsChart/>



            </Row>
            {/*<IndicatorDescription/>*/}
        </IndicatorsPage>
    )
}



export default MyIndicatorsPage
